module.exports = __webpack_public_path__ + "static/media/epsUSDN.dca169c3.png";